import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import logoIcon from '../assets/logo-white.png';
import shot1 from '../assets/customer-booking.png';
import shot2 from '../assets/screenshot2.png';
import shot3 from '../assets/customer-summary.png';
import phoneFrame from '../assets/phone-frame.png';
import sparkiLongNavLogo from '../assets/sparki-long.png';

const carouselShots = [shot1, shot2, shot3];

const Hero: React.FC = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setCurrent(c => (c + 1) % carouselShots.length), 4000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="container hero-section">
      <div className="navbar">
        <img
          src={sparkiLongNavLogo}
          alt="Sparki"
          className="navbar-logo"
        />
        <a
          href="https://garage.sparkiapp.com"
          className="small-login-link"
          target="_blank"
          rel="noopener"
          aria-label="Garage login"
        >
          <span>Garage login</span>
          <span aria-hidden="true"> →</span>
        </a>
      </div>

      <div className="hero-text">
        <img src={logoIcon} alt="Sparki" className="hero-main-logo" />

        <h1 className="hero-title">
          Power your garage with Sparki
          <span style={{ fontSize: '0.5em', verticalAlign: 'super', marginLeft: '0.15em' }}>™</span>
        </h1>

        <p className="hero-subline">
          Your own mobile app for you &amp; your customers
        </p>

        <Link to="/get-started" className="cta">
          Get started for free
        </Link>
      </div>

      <div className="hero-carousel-panel">
        <div className="hero-phone-mockup">
          {/* white “screen” fill exactly where your screenshots go */}
          <div className="hero-screen-window" />

          {/* cross-fade shots */}
          {carouselShots.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`App screenshot ${i + 1}`}
              className="hero-phone-screenshot"
              style={{ opacity: i === current ? 1 : 0 }}
            />
          ))}

          {/* your transparent bezel on top */}
          <img
            src={phoneFrame}
            alt="Phone frame"
            className="hero-phone-frame"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
